import { flowRight } from 'lodash';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import PopupWidgetProfileActions from '../../containers/popup-widget-profile-actions';
import Wix from '../../services/wix-sdk-polyfill';
import {
  popupToggled,
  popupLoaded,
  hidePopup,
  COMMUNITIES_POPUP_SHOW,
  COMMUNITIES_POPUP_HIDE,
} from '../../services/widget-popup';
import withCardBackgroundColor from '../../hoc/with-card-background-color';
import withFontClassName from '../../hoc/with-font-class-name';
import styles from './profile-actions-widget.scss';

export class ProfileActionsWidget extends Component {
  state = {
    style: {},
  };

  componentDidMount = () => {
    popupLoaded();
    Wix.PubSub.subscribe(COMMUNITIES_POPUP_SHOW, this.showPopup);
    Wix.PubSub.subscribe(COMMUNITIES_POPUP_HIDE, this.hidePopup);
  };

  componentWillUnmount = () => {
    Wix.PubSub.unsubscribe(COMMUNITIES_POPUP_SHOW, this.showPopup);
    Wix.PubSub.unsubscribe(COMMUNITIES_POPUP_HIDE, this.hidePopup);
  };

  getTriangleCenterPosition = () => {
    const containerRect = this.container.getBoundingClientRect();
    const triangleRect = this.triangleRef.getBoundingClientRect();
    const triangleCenterPosition = triangleRect.left + triangleRect.width / 2;
    const triangleCenterPositionRelativeToContainer = triangleCenterPosition - containerRect.left;
    return triangleCenterPositionRelativeToContainer;
  };

  showPopup = ({ data: { x, y } }) => {
    this.setState({
      style: {
        marginLeft: x - this.getTriangleCenterPosition(),
        marginTop: y,
      },
    });
    Wix.setHeight(10000);
    popupToggled();
  };

  hidePopup = () => {
    Wix.setHeight(0);
  };

  handleHidePopup = () => {
    hidePopup();
  };

  setContainer = container => {
    this.container = container;
  };

  setTriangleRef = el => {
    this.triangleRef = el;
  };

  render = () => {
    const { cardBackgroundColor, contentFontClassName } = this.props;
    const actionsClassName = classNames(
      styles.container,
      styles.right,
      contentFontClassName,
      'forum-text-color',
      'forum-card-border-color',
      'default-forum-card-background-color'
    );

    const triangleClassName = classNames(
      styles.triangle,
      'forum-card-border-color',
      'default-forum-card-background-color'
    );
    const backgroundStyle = {
      backgroundColor: cardBackgroundColor,
    };

    return (
      <div onClick={this.handleHidePopup} className={styles.overlay}>
        <div className={styles.wrapper} style={this.state.style} ref={this.setContainer}>
          <div className={actionsClassName}>
            <div className={triangleClassName} style={backgroundStyle} ref={this.setTriangleRef}/>
            <div className="default-forum-card-background-color" style={backgroundStyle}>
              <PopupWidgetProfileActions/>
            </div>
          </div>
        </div>
      </div>
    );
  };
}

ProfileActionsWidget.propTypes = {
  cardBackgroundColor: PropTypes.string,
  contentFontClassName: PropTypes.string,
};

export default flowRight(
  withCardBackgroundColor,
  withFontClassName,
)(ProfileActionsWidget);



// WEBPACK FOOTER //
// ./app/containers/profile-actions-widget/profile-actions-widget.js